<callcard-detail-home *ngIf="callcard && page==0" [callcard]="callcard"></callcard-detail-home>
<callcard-followup *ngIf="callcard && page==1" [callcard]="callcard"></callcard-followup>
<!-- OBSOLETE <callcard-sip *ngIf="callcard && callcard.page==2" [callcard]="callcard"></callcard-sip> -->
